export const IS_LOCAL = window.location.host.includes('localhost');
